module.exports = __webpack_public_path__ + "img/concern_header.27dd9e6f.png";